import styles from "./LoanRequestCards.module.scss";
import { CountResponse } from "../../LoanRequestPage";
import { formatNumber } from "../../../../../utils";

type Props = {
	data: CountResponse;
};

const LoanRequestCards = ({ data }: Props) => {

	return (
		<div className={styles.cardsContainer}>
			<div className={`${styles.card} ${styles.totalRequestCard}`}>
				<div className={styles.cardHeader}>Total Request</div>
				<div className={styles.cardBody}>{formatNumber(data?.totalCount || "-")}</div>
			</div>
			<div className={`${styles.card} ${styles.pendingRequestCard}`}>
				<div className={styles.cardHeader}>Pending Request</div>
				<div className={styles.cardBody}>{formatNumber(data?.pendingCount || "-")}</div>
			</div>
			<div className={`${styles.card} ${styles.approvedRequestCard}`}>
				<div className={styles.cardHeader}>Approved Request</div>
				<div className={styles.cardBody}>{formatNumber(data?.approvedCount || "-")}</div>
			</div>
			<div className={`${styles.card} ${styles.declinedRequestCard}`}>
				<div className={styles.cardHeader}>Declined Request</div>
				<div className={styles.cardBody}>{formatNumber(data?.declinedCount || "-")}</div>
			</div>
		</div>
	);
};

export default LoanRequestCards;
